﻿window.askue2loginpage = function () {
	var instance = {
		widgetDidMount: function (state) {
			var h = document.getElementById('height');
			h.value = parseInt(window.screen.availHeight * window.devicePixelRatio);

			var w = document.getElementById('width');
			w.value = parseInt(window.screen.availWidth * window.devicePixelRatio);

		}
	}
	return instance;
}();